import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../shared/ui/Button';
import { Card } from '../../../shared/ui/Card';
import { Field } from '../../../shared/ui/Field';
import { Input } from '../../../shared/ui/Input';
import { useCreateAdmin } from '../hooks/useCreateAdmin';
import styles from './CreateAdminForm.module.css';

// PARA-114, AC-2/AC-E1/AC-E2: форма login/password -> POST /admin/admins;
// generic-ошибка (role="alert") на 409/422, без разбора конкретного кода
// (по паттерну LoginPage, PARA-106).
export function CreateAdminForm(): JSX.Element {
  const { t } = useTranslation();
  const { mutate, isPending, isError } = useCreateAdmin();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (event: FormEvent): void => {
    event.preventDefault();
    mutate(
      { login, password },
      {
        onSuccess: () => {
          setLogin('');
          setPassword('');
        },
      },
    );
  };

  return (
    <Card>
      <form className={styles.form} onSubmit={handleSubmit}>
        <Field className={styles.field} label={t('admins.createLogin')} htmlFor="admin-login">
          <Input
            id="admin-login"
            value={login}
            onChange={(event) => setLogin(event.target.value)}
            autoComplete="username"
          />
        </Field>
        <Field className={styles.field} label={t('admins.createPassword')} htmlFor="admin-password">
          <Input
            id="admin-password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="new-password"
          />
        </Field>
        <Button type="submit" disabled={isPending}>
          {t('admins.createSubmit')}
        </Button>
        {isError && (
          <p className={styles.error} role="alert">
            {t('admins.createError')}
          </p>
        )}
      </form>
    </Card>
  );
}
